import { LotteryId } from '~~/layers/core/api/shared/@types/generated/backend/graphql-schema-types'

export const getLotteryIdInCorrectCase = (anyCaseLotteryId?: unknown) =>
  Object.values(LotteryId).find(
    (lotteryId) => lotteryId.toLowerCase() === String(anyCaseLotteryId).toLowerCase(),
  ) ?? null
